/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineExtraStayDetailsRsDto } from './traveline-extra-stay-details-rs-dto';
import {
    TravelineExtraStayDetailsRsDtoFromJSON,
    TravelineExtraStayDetailsRsDtoFromJSONTyped,
    TravelineExtraStayDetailsRsDtoToJSON,
    TravelineExtraStayDetailsRsDtoToJSONTyped,
} from './traveline-extra-stay-details-rs-dto';

/**
 * 
 * @export
 * @interface TravelineExtraStaysChargeDto
 */
export interface TravelineExtraStaysChargeDto {
    /**
     * 
     * @type {TravelineExtraStayDetailsRsDto}
     * @memberof TravelineExtraStaysChargeDto
     */
    earlyArrival?: TravelineExtraStayDetailsRsDto;
    /**
     * 
     * @type {TravelineExtraStayDetailsRsDto}
     * @memberof TravelineExtraStaysChargeDto
     */
    lateDeparture?: TravelineExtraStayDetailsRsDto;
}

/**
 * Check if a given object implements the TravelineExtraStaysChargeDto interface.
 */
export function instanceOfTravelineExtraStaysChargeDto(value: object): value is TravelineExtraStaysChargeDto {
    return true;
}

export function TravelineExtraStaysChargeDtoFromJSON(json: any): TravelineExtraStaysChargeDto {
    return TravelineExtraStaysChargeDtoFromJSONTyped(json, false);
}

export function TravelineExtraStaysChargeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineExtraStaysChargeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'earlyArrival': json['earlyArrival'] == null ? undefined : TravelineExtraStayDetailsRsDtoFromJSON(json['earlyArrival']),
        'lateDeparture': json['lateDeparture'] == null ? undefined : TravelineExtraStayDetailsRsDtoFromJSON(json['lateDeparture']),
    };
}

  export function TravelineExtraStaysChargeDtoToJSON(json: any): TravelineExtraStaysChargeDto {
      return TravelineExtraStaysChargeDtoToJSONTyped(json, false);
  }

  export function TravelineExtraStaysChargeDtoToJSONTyped(value?: TravelineExtraStaysChargeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'earlyArrival': TravelineExtraStayDetailsRsDtoToJSON(value['earlyArrival']),
        'lateDeparture': TravelineExtraStayDetailsRsDtoToJSON(value['lateDeparture']),
    };
}

